import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { StudentService } from 'src/app/shared/services/student.service';

@Component({
  selector: 'app-parentalconsent',
  templateUrl: './parentalconsent.component.html',
  styleUrls: ['./parentalconsent.component.scss'],
  standalone: false,
})
export class ParentalconsentComponent implements OnInit {
  profileId: string = '';
  token: string = '';
  isProcessing: boolean = false;

  constructor(
    public activatedRoute: ActivatedRoute,
    public router: Router,
    private modalService: ModalService,
    private alertService: AlertService,
    private studentService: StudentService,
    private translateService: TranslateService
  ) {}

  ngOnInit(): void {
    // Get profileId and token from route params
    this.activatedRoute.params.subscribe((params) => {
      this.profileId = params['id'] || '';
      this.token = params['token'] || '';
    });
  }

  /**
   * Give consent using the actual API endpoint
   */
  giveConsent(): void {
    if (this.isProcessing || !this.profileId || !this.token) {
      this.alertService.error(
        this.translateService.instant(
          'Invalid consent link. Please contact us for help.'
        )
      );
      return;
    }

    this.isProcessing = true;
    this.modalService.Loader(true);

    this.studentService
      .apiGiveParentalConsent(this.profileId, this.token)
      .pipe(
        catchError((error) => {
          this.handleError(error);
          return of(null);
        })
      )
      .subscribe((response) => {
        if (response !== null) {
          this.handleSuccess();
        }
      });
  }

  /**
   * Handle successful consent
   */
  private handleSuccess(): void {
    this.modalService.Loader(false);
    this.isProcessing = false;

    this.alertService.success(
      this.translateService.instant(
        'Thank you! Your child can now use the platform.'
      )
    );
    this.modalService.Alert(
      this.translateService.instant('Permission granted'),
      this.translateService.instant(
        'Your child can now start using the platform to find internships and jobs. You will receive a confirmation email shortly.'
      )
    );
  }

  /**
   * Handle errors
   */
  private handleError(error: any): void {
    this.modalService.Loader(false);
    this.isProcessing = false;

    console.error('Error processing consent:', error);

    // Handle specific error cases if needed
    if (error.status === 400) {
      this.alertService.error(
        this.translateService.instant(
          'Invalid consent token. Please contact us for help.'
        )
      );
    } else if (error.status === 404) {
      this.alertService.error(
        this.translateService.instant(
          'Student profile not found. Please contact us for help.'
        )
      );
    } else {
      this.alertService.error(
        this.translateService.instant(
          'Something went wrong. Please try again or contact us.'
        )
      );
    }
  }
}
